import LightboxDialog from './LightboxDialog';

export default LightboxDialog;
